<template>
  <ContentCard title="系统通知" rightTitle="更多" @rightClick="goMore">
    <InfoList :list="list" @detail="openNoticePage"></InfoList>
  </ContentCard>
</template>

<script>
import { noticeGetPaged } from '@/api/siteserver'
import { getFilter1 } from '@/utils/config'
import { store } from '@ice/stark-data'
import ContentCard from '@/components/ContentCard'
import InfoList from '@/components/InfoList'

export default {
	name: "SystemNotice",
  components: { ContentCard, InfoList },
  data() {
    return {
      list: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      try {
        let filter = getFilter1("系统通知")
        const { result, success } = await noticeGetPaged({
          filter,
          order: 'createdDate desc',
          pageNum: 1,
          pageSize: 10
        })
        if(success && result.totalCount) this.list = result.items
      } catch(e) {
        console.log(e)
      }
    },
    openNoticePage(item) {
			this.$router.push({ path: '/infoDetail', query: { cId: item.id }})
		},
    goMore() {
      store.set('nType', '系统公告')
      this.$router.push({ name: 'purchaseInfo' })
    },
    
  }
};
</script>

<style lang="less" scoped>
.noData {
  text-align: center;
}
.system-notice {
  height: 40px;
  width: 100%;
  cursor: pointer;
  :hover {
    background-color: #e5efec;
    color: #0E8FA5;
  }
  .system-notice-div {
    display: flex;
    justify-content: space-between;
    line-height: 40px;
  }
  .system-notice-time {
    width: 120px;
    text-align: center;
  }
}
</style>
